import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // Replace with your API URL
  withCredentials: true,
});

// sample API structure
export const checkUserSession = async () => {
  const response = await API.get(`/auth/check-session/`);
  localStorage.setItem("user_id", JSON.stringify(response.data.user_id));
  return response;
};

export const refreshUserSession = async () => {
  const response = await API.post(`/auth/token/refresh/`, {}, {});
  return response;
}

export const getCSRFToken = async () => {
  const response = await API.get(`/csrf-token/`);
  return response;
};
